import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine } from "recharts";

export default function PerformanceChart({ races }) {
  if (!races?.length) return null;

  const chartData = [...races]
    .reverse()
    .map((r, i) => ({
      race: i + 1,
      position: r.position,
      date: r.date,
      track: r.track_name,
    }));

  const maxPos = Math.max(...chartData.map(d => d.position));

  return (
    <div data-testid="performance-chart" className="border border-border p-4 bg-white">
      <p className="mono-label text-zinc-400 mb-4">Position Over Last {races.length} Races</p>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={chartData} margin={{ top: 10, right: 10, bottom: 10, left: 0 }}>
          <XAxis
            dataKey="race"
            tick={{ fontSize: 10, fontFamily: 'JetBrains Mono', fill: '#71717A' }}
            axisLine={{ stroke: '#E4E4E7' }}
            tickLine={false}
          />
          <YAxis
            reversed
            domain={[1, Math.min(maxPos + 1, 16)]}
            tick={{ fontSize: 10, fontFamily: 'JetBrains Mono', fill: '#71717A' }}
            axisLine={false}
            tickLine={false}
            width={24}
          />
          <ReferenceLine y={1} stroke="#008A27" strokeDasharray="3 3" strokeOpacity={0.5} />
          <ReferenceLine y={3} stroke="#E4E4E7" strokeDasharray="2 2" />
          <Tooltip
            contentStyle={{
              background: '#09090B',
              border: 'none',
              borderRadius: '4px',
              fontSize: '12px',
              fontFamily: 'JetBrains Mono',
              color: '#fff',
            }}
            formatter={(value) => [`Position: ${value}`, '']}
            labelFormatter={(label, payload) => {
              if (payload && payload[0]) {
                return `${payload[0].payload.date} - ${payload[0].payload.track}`;
              }
              return `Race ${label}`;
            }}
          />
          <Line
            type="monotone"
            dataKey="position"
            stroke="#09090B"
            strokeWidth={2}
            dot={{ r: 4, fill: '#09090B', stroke: '#fff', strokeWidth: 2 }}
            activeDot={{ r: 6, fill: '#E12B00', stroke: '#fff', strokeWidth: 2 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
